module.exports = __webpack_public_path__ + "img/Icon_Home.caddc59e.jpg";